// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file requests/v1/enabled_shipping_types_update_provider_request.proto (package requests.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import { file_buf_validate_validate } from '../../buf/validate/validate_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file requests/v1/enabled_shipping_types_update_provider_request.proto.
 */
export const file_requests_v1_enabled_shipping_types_update_provider_request: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CkByZXF1ZXN0cy92MS9lbmFibGVkX3NoaXBwaW5nX3R5cGVzX3VwZGF0ZV9wcm92aWRlcl9yZXF1ZXN0LnByb3RvEgtyZXF1ZXN0cy52MSLoAQopRW5hYmxlZFNoaXBwaW5nVHlwZXNVcGRhdGVQcm92aWRlclJlcXVlc3QSawoWY291bnRyeV9zaGlwcGluZ190eXBlcxgBIAMoCzJLLnJlcXVlc3RzLnYxLkVuYWJsZWRTaGlwcGluZ1R5cGVzVXBkYXRlUHJvdmlkZXJSZXF1ZXN0LkNvdW50cnlTaGlwcGluZ1R5cGVzGk4KFENvdW50cnlTaGlwcGluZ1R5cGVzEh4KDGNvdW50cnlfY29kZRgBIAEoCUIIukgFcgOYAQISFgoOc2hpcHBpbmdfdHlwZXMYAiADKAlClAEKD2NvbS5yZXF1ZXN0cy52MUIuRW5hYmxlZFNoaXBwaW5nVHlwZXNVcGRhdGVQcm92aWRlclJlcXVlc3RQcm90b1ABWgQuL3BiogIDUlhYqgILUmVxdWVzdHMuVjHKAgtSZXF1ZXN0c1xWMeICF1JlcXVlc3RzXFYxXEdQQk1ldGFkYXRh6gIMUmVxdWVzdHM6OlYxYgZwcm90bzM',
        [file_buf_validate_validate]
    );

/**
 * @generated from message requests.v1.EnabledShippingTypesUpdateProviderRequest
 */
export type EnabledShippingTypesUpdateProviderRequest =
    Message<'requests.v1.EnabledShippingTypesUpdateProviderRequest'> & {
        /**
         * @generated from field: repeated requests.v1.EnabledShippingTypesUpdateProviderRequest.CountryShippingTypes country_shipping_types = 1;
         */
        countryShippingTypes: EnabledShippingTypesUpdateProviderRequest_CountryShippingTypes[];
    };

/**
 * Describes the message requests.v1.EnabledShippingTypesUpdateProviderRequest.
 * Use `create(EnabledShippingTypesUpdateProviderRequestSchema)` to create a new message.
 */
export const EnabledShippingTypesUpdateProviderRequestSchema: GenMessage<EnabledShippingTypesUpdateProviderRequest> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_enabled_shipping_types_update_provider_request, 0);

/**
 * @generated from message requests.v1.EnabledShippingTypesUpdateProviderRequest.CountryShippingTypes
 */
export type EnabledShippingTypesUpdateProviderRequest_CountryShippingTypes =
    Message<'requests.v1.EnabledShippingTypesUpdateProviderRequest.CountryShippingTypes'> & {
        /**
         * @generated from field: string country_code = 1;
         */
        countryCode: string;

        /**
         * @generated from field: repeated string shipping_types = 2;
         */
        shippingTypes: string[];
    };

/**
 * Describes the message requests.v1.EnabledShippingTypesUpdateProviderRequest.CountryShippingTypes.
 * Use `create(EnabledShippingTypesUpdateProviderRequest_CountryShippingTypesSchema)` to create a new message.
 */
export const EnabledShippingTypesUpdateProviderRequest_CountryShippingTypesSchema: GenMessage<EnabledShippingTypesUpdateProviderRequest_CountryShippingTypes> =
    /*@__PURE__*/
    messageDesc(file_requests_v1_enabled_shipping_types_update_provider_request, 0, 0);
